import { render, staticRenderFns } from "./OrderXsInvoice.vue?vue&type=template&id=9d9ac340&scoped=true"
import script from "./OrderXsInvoice.vue?vue&type=script&lang=js"
export * from "./OrderXsInvoice.vue?vue&type=script&lang=js"
import style0 from "./OrderXsInvoice.vue?vue&type=style&index=0&id=9d9ac340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9ac340",
  null
  
)

export default component.exports